// extracted by mini-css-extract-plugin
module.exports = {"root":"NumbersCard_root__jgIKU","title":"NumbersCard_title__N7Z1i","description":"NumbersCard_description__SFuOl","rotation":"NumbersCard_rotation__fyYf_"};